import React from "react";
import { useParams } from "react-router-dom";
import PartnerDashboardView from "../../../../../../features/partner-dashboard/PartnerDashboardView";

const PartnerDashboard: React.FC = () => {
  const { ID } = useParams();

  return <PartnerDashboardView partnerId={Number(ID)} variant="admin" />;
};

export default PartnerDashboard;
